import(/* webpackMode: "eager" */ "E:\\vhosts\\paykanpars.com\\httpdocs\\src\\app\\error.tsx");
